import type { AccentPalette } from "../types";

export const ACCENT_TABLEAU: AccentPalette = {
    label: "Tableau",
    inflow: { base: "#3FA08A", selected: "#5FC0A9" },
    outflow: { base: "#D98A52", selected: "#E6AC82" },
    icons: {
        "ri-account-circle-line": { pillHex: "#C9DBED", chartHex: "#3D78B8" },
        "ri-arrow-left-right-line": { pillHex: "#EDDBC9", chartHex: "#C78E56" },
        "ri-bank-card-line": { pillHex: "#EDC9CA", chartHex: "#CE6B6C" },
        "ri-bank-line": { pillHex: "#C9EDEA", chartHex: "#62CBC3" },
        "ri-bill-line": { pillHex: "#CEEDC9", chartHex: "#4BB43C" },
        "ri-book-2-line": { pillHex: "#EDE5C9", chartHex: "#CDB768" },
        "ri-bookmark-line": { pillHex: "#EDC9E3", chartHex: "#CA60AD" },
        "ri-box-3-line": { pillHex: "#EDC9CD", chartHex: "#E7B6BB" },
        "ri-briefcase-line": { pillHex: "#EDD6C9", chartHex: "#BC6C3F" },
        "ri-building-line": { pillHex: "#EDD4C9", chartHex: "#D9A38D" },
        "ri-calculator-line": { pillHex: "#C9EDE9", chartHex: "#72D0C6" },
        "ri-car-line": { pillHex: "#EDC9D6", chartHex: "#D17496" },
        "ri-cash-line": { pillHex: "#C9DBED", chartHex: "#5E94C9" },
        "ri-coins-line": { pillHex: "#EDC9D1", chartHex: "#D47D8F" },
        "ri-computer-line": { pillHex: "#C9EDCC", chartHex: "#40BF4A" },
        "ri-exchange-dollar-line": { pillHex: "#D7C9ED", chartHex: "#875EC9" },
        "ri-file-list-3-line": { pillHex: "#EDE1C9", chartHex: "#D4B77D" },
        "ri-file-paper-2-line": { pillHex: "#C9EDEC", chartHex: "#40BFBA" },
        "ri-funds-line": { pillHex: "#EDC9E4", chartHex: "#C95EAF" },
        "ri-gift-line": { pillHex: "#DAEDC9", chartHex: "#A5D47D" },
        "ri-government-line": { pillHex: "#C9CFED", chartHex: "#4055BF" },
        "ri-group-line": { pillHex: "#EDCEC9", chartHex: "#C96C5E" },
        "ri-hammer-line": { pillHex: "#C9EDD8", chartHex: "#7DD4A1" },
        "ri-hand-coin-line": { pillHex: "#E3C9ED", chartHex: "#9A40BF" },
        "ri-home-8-line": { pillHex: "#EDEDC9", chartHex: "#C9C95E" },
        "ri-landscape-line": { pillHex: "#C9E3ED", chartHex: "#7DBAD4" },
        "ri-lightbulb-line": { pillHex: "#EDC9D8", chartHex: "#BF4075" },
        "ri-line-chart-line": { pillHex: "#CEEDC9", chartHex: "#6CC95E" },
        "ri-macbook-line": { pillHex: "#CFC9ED", chartHex: "#8B7DD4" },
        "ri-megaphone-line": { pillHex: "#EDDAC9", chartHex: "#BF7A40" },
        "ri-money-dollar-circle-line": { pillHex: "#C9EDE4", chartHex: "#5EC9AF" },
        "ri-percent-line": { pillHex: "#EDC9EC", chartHex: "#D47DD0" },
        "ri-pie-chart-2-line": { pillHex: "#E1EDC9", chartHex: "#95BF40" },
        "ri-pie-chart-line": { pillHex: "#C9D7ED", chartHex: "#5E87C9" },
        "ri-printer-line": { pillHex: "#EDC9CC", chartHex: "#D47D84" },
        "ri-question-line": { pillHex: "#C9EDD1", chartHex: "#40BF5A" },
        "ri-receipt-line": { pillHex: "#DBC9ED", chartHex: "#945EC9" },
        "ri-safe-line": { pillHex: "#EDE6C9", chartHex: "#D4C27D" },
        "ri-scales-3-line": { pillHex: "#C9EAED", chartHex: "#40B5BF" },
        "ri-settings-4-line": { pillHex: "#EDC9E0", chartHex: "#C95EA1" },
        "ri-shake-hands-line": { pillHex: "#D5EDC9", chartHex: "#9AD47D" },
        "ri-shield-check-line": { pillHex: "#C9CBED", chartHex: "#4045BF" },
        "ri-shopping-bag-3-line": { pillHex: "#EDD2C9", chartHex: "#C9795E" },
        "ri-stock-line": { pillHex: "#C9EDDD", chartHex: "#7DD4AC" },
        "ri-store-2-line": { pillHex: "#E7C9ED", chartHex: "#AA40BF" },
        "ri-team-line": { pillHex: "#E9EDC9", chartHex: "#BCC95E" },
        "ri-time-line": { pillHex: "#C9DEED", chartHex: "#7DB0D4" },
        "ri-timer-line": { pillHex: "#EDC9D4", chartHex: "#BF4065" },
        "ri-tools-line": { pillHex: "#C9EDC9", chartHex: "#5EC95E" },
        "ri-truck-line": { pillHex: "#D4C9ED", chartHex: "#967DD4" },
        "ri-umbrella-line": { pillHex: "#EDDEC9", chartHex: "#BF8A40" },
        "ri-user-settings-line": { pillHex: "#C9EDE9", chartHex: "#5EC9BC" },
        "ri-wallet-line": { pillHex: "#EDC9E7", chartHex: "#D47DC5" },
    },
};
